import React, { useState, useEffect, use, } from 'react'
import Loader from '../components/Loader';


import 'select2/dist/css/select2.min.css';
import 'select2';

import { useNavigate, } from 'react-router-dom';
import { userListByDB } from '../api/user';
import { addGroup } from '../api/group';

import { useParams } from 'react-router-dom';
import PopupModal from '../components/PopupModal';
import useUserStore from '../store/useUserStore';
import { extractBadgeDetails } from '../utils/badgeFormatter';


export default function AddGroup() {
    const navigate = useNavigate();
    const { id } = useParams();
    const { user } = useUserStore();
    const [showPopup, setShowPopup] = useState(false);
    const [popUpMessage, setPopUpMessage] = useState({ "title": "", "text": "" })
    const [loading, setLoading] = useState(false);
    const [users, setUsers] = useState([]);
    const [errors, setErrors] = useState({
        badgeTopics: []
    });
    const [apiError, setApiError] = useState('');
    const [errorStatus, setErrorStatus] = useState("success");

    const delay = ms => new Promise(resolve => setTimeout(resolve, ms));




    const getAllUserData = async () => {
        try {
            const res = await userListByDB(user?.db);
            if (res.status > 199 && res.status < 400) {
                let data = res.data.data;
                console.log("User List", data);
                setUsers(data);
            } else {
                setApiError("There are some technical issue, please try again after sometime");
                setErrorStatus("danger");
                setUsers([]);
            }
        } catch (error) {
            setApiError("There are some technical issue, please try again after sometime");
            setErrorStatus("danger");
            setUsers([]);
        }
    };

    useEffect(() => {
        getAllUserData();
    }, []);


    let formInput = {
        content: "",
        title: "",
    };
    let [formData, setFormData] = useState(formInput);



    const validate = () => {
        let newErrors = {}
        // if (!formData.content) newErrors.content = 'Content is required';
        if (!formData.title) newErrors.title = 'Title is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };



    const handleSaveGroup = async (e) => {
        e.preventDefault();

        // if (!validate()) {
        //     setApiError("Please add required fields")
        //     setErrorStatus('danger')
        //     return;
        // }
        try {

            setLoading(true);

            const userList = formData.content.map(email => ({
                email,
                status: "Active"
            }));

            delete formData.content;
            formData = {
                ...formData,
                userList
            }

            let response = await addGroup(formData, id);
            if (response.status > 199 && response.status < 400) {
                setFormData(formInput);

                setPopUpMessage({
                    "title": "Success",
                    "text": `News ${id ? "edited" : "added"} successfully`
                });
                setShowPopup(true);
            } else {
                console.log("response", response);
                setPopUpMessage({
                    "title": "Error",
                    "text": response?.response?.data?.errors?.content || "There are some technical issue,please try again after sometimes"
                });
                setShowPopup(true);
            }
        } catch (error) {
            console.log("error", error);
            const message = error?.data?.message || error?.statusText || 'Login failed';
            setApiError(message);
            setTimeout(() => {
                setApiError(null);
                setErrorStatus('danger')

            }, 5000);
        } finally {
            setLoading(false);
        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target;

        // Update form data
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        // Update errors
        setErrors((prev) => {
            const newErrors = { ...prev };
            if (!value || value.trim() === "") {
                newErrors[name] = `${name} is required`;
            } else {
                delete newErrors[name];
            }
            return newErrors;
        });
    };

    useEffect(() => {
        const script = document.createElement("script");
        script.src = `${process.env.PUBLIC_URL}/assets/js/misc.js`;
        script.async = true;

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script); // cleanup
        };
    });
    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        if (checked) {
            setFormData((prev) => ({
                ...prev,
                content: [...prev.content, name],
            }));
        } else {
            setFormData((prev) => ({
                ...prev,
                content: prev.content.filter((item) => item !== name),
            }));
        }
    };
    const HandleGoTO = async () => {
        navigate(`/group`)
    }
    return (
        <>
            {loading && <Loader />}
            <PopupModal
                isOpen={showPopup}
                data={popUpMessage}
                onClose={() => {
                    setShowPopup(false)
                    setPopUpMessage({
                        "title": "",
                        "text": ""
                    })
                }}
            />


            <form onSubmit={handleSaveGroup}>
                <div className="content-wrapper">
                    <div className="page-header">
                        <h3 className="page-title"> Add Group </h3>
                        {apiError && <div className={`alert alert-${errorStatus} mb-4`}> {apiError}</div>}

                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <button type="submit" className="btn btn-primary me-2">Save</button>
                                <button type="button" onClick={HandleGoTO} className="btn btn-success me-2">Back</button>
                            </ol>

                        </nav>
                    </div>
                    <div className="row">

                        <div className="col-md-12 grid-margin stretch-card">
                            <div className="card">
                                <div className="card-body">
                                    <h4 className="card-title"></h4>
                                    {/* <p className="card-description"> Basic form layout </p> */}


                                    <div className="form-group">
                                        <label >Title</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="title"
                                            value={formData.title}
                                            onChange={handleChange}
                                            placeholder="title" />
                                        {errors.title && <span className="text-danger">{errors.title}</span>}
                                    </div>
                                    <div className="card-body">
                                        <div className="row">

                                            {
                                                users.length > 0 && users.map((user) => {
                                                    return (
                                                        <div className="col-md-4">
                                                            <div className="form-group1">
                                                                <div className="form-check form-check-success" key={user._id}>
                                                                    <label className="form-check-label">
                                                                        <input
                                                                            name={user.email}
                                                                            type="checkbox"
                                                                            className="form-check-input"
                                                                            //checked={formData.cnsImportZeroTax}
                                                                            onChange={handleCheckboxChange}
                                                                        /> {user.name} </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }

                                        </div>

                                    </div>



                                </div>
                            </div>
                        </div>



                    </div>
                </div>
            </form>
        </>

    )
}
